import React, {
  FC, useEffect, useState,
} from 'react';
import { Cab, Driver } from '../../../../lib/types';
import { getFoodifoxDataLazy } from '../../../../lib/axios/FoodifoxDataAPI';
import Button from '../../../../components/Button';
import TermsConditionsModal from '../../Common/TermsConditionsModal';
import SquadBoldItalicText from '../../../../components/Text/SquadBoldItalicText';
import SquadRegularItalicText from '../../../../components/Text/SquadRegularItalicText';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import { Dhl } from '../../../../assets/base64Images/home/platform/dhl';
import { Amazon } from '../../../../assets/base64Images/home/platform/amazon';
import { AusPost } from '../../../../assets/base64Images/home/platform/ausPost';
import { HelloFresh } from '../../../../assets/base64Images/home/platform/helloFresh';
import { Toll } from '../../../../assets/base64Images/home/platform/toll';
import { Panda } from '../../../../assets/base64Images/home/platform/panda';
import { Fantuan } from '../../../../assets/base64Images/home/platform/fantuan';
import { Uber } from '../../../../assets/base64Images/home/platform/uber';
import { Dash } from '../../../../assets/base64Images/home/platform/dash';
import { MenuLog } from '../../../../assets/base64Images/home/platform/menuLog';
import Loading from '../../../../components/Loading';
import InterBoldItalicText from '../../../../components/Text/InterBoldItalicText';
import InterItalicText from '../../../../components/Text/InterItalicText';

const FoodItem: FC<Props> = ({
  setTargetPage,
  isEnglish,
  setDriverId,
  cabId,
  cab,
  setSmallCabId,
  setLargeCabId,
}) => {
  const [getCabGroupList, { loading: getCabGroupListLoading }] = getFoodifoxDataLazy<Cab[]>('/foxH5Home/getCabGroupList');

  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [isAgreeTerms, setIsAgreeTerms] = useState<boolean>();
  const [showAgreeTermsBtn, setShowAgreeTermsBtn] = useState<boolean>(false);
  const [showTermsConditionsModal, setShowTermsConditionsModal] = useState<boolean>(false);

  useEffect(() => {
    setShowLoading(getCabGroupListLoading);

    return () => {
      setShowLoading(false);
    };
  }, [getCabGroupListLoading]);

  useEffect(() => {
    if (isAgreeTerms) {
      setTargetPage('food-create-driver');
      setIsAgreeTerms(undefined);
      // 同意协议后，设置本地缓存
      localStorage.setItem('driver-agree-terms', 'Y');
    }
  }, [isAgreeTerms]);

  /**
   * 需要先同意条款与条件
   */
  const checkTerms = () => {
    // // 查询司机是否已同意协议
    // checkDriverTerms({
    //   param: {
    //     deviceCode,
    //     ckDeviceFirebaseId: ckFirebaseId,
    //   },
    //   onCompleted(driverData) {
    //     if (!driverData) {
    //       // 同意过协议，直接跳转到创建司机页面
    //       if (localStorage.getItem('driver-agree-terms')) {
    //         setTargetPage('food-create-driver');
    //         return;
    //       }
    //       // 没有确认协议时，弹出协议确认框
    //       setShowAgreeTermsBtn(true);
    //       setShowTermsConditionsModal(true);
    //       return;
    //     }
    //
    //     const { driverId } = driverData;
    //     setDriverId(driverId);
    //     setTargetPage('food-platform-select');
    //     setShowLoading(false);
    //   },
    // });
    // 不要同意协议，直接跳转到下载App页面
    setTargetPage('download-app');
  };

  /**
   * 送餐时，先获取组合柜信息，然后再检测是否确认了协议
   */
  const getCabGroup = () => {
    if (!cab) {
      return;
    }

    // 先获取组合柜列表
    getCabGroupList({
      param: {
        cabId: cab.cabId
      },
      onCompleted(groupList) {
        (groupList || []).map(({ cabId, cabSizeType }) => {
          // 设置小柜子ID
          if ('small' === cabSizeType) {
            setSmallCabId(cabId);
          }
          // 设置大柜子ID
          else if ('large' === cabSizeType) {
            setLargeCabId(cabId);
          }
        });

        // 检测是否确认了协议
        checkTerms();
      },
    });
  };

  return (
    <>
      {
        (showLoading) && (
          <Loading />
        )
      }
      {
        showTermsConditionsModal && (
          <TermsConditionsModal
            callback={(isAgree) => {
              setIsAgreeTerms(isAgree);
              setShowTermsConditionsModal(false);
            }}
            showAgreeBtn={showAgreeTermsBtn}
            showExitBtn={showAgreeTermsBtn}
            isEnglish={isEnglish}
          />
        )
      }

      {/* 送餐入口 */}
      <Button
        minWidth={156}
        maxWidth={156}
        minHeight={156}
        maxHeight={156}
        backgroundColor={'#00D2B9'}
        borderRadius={'50%'}
        marginTop={15}
        style={{ border: '2px solid #000000', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
        onClick={() => {
          checkTerms();
        }}
      >
        {
          isEnglish ? (
            <>
              <InterBoldItalicText color={'#FFFFFF'} fontSize={24}>
                Drivers
              </InterBoldItalicText>
              <InterItalicText color={'#FFFFFF'} fontSize={16} marginTop={-3}>
                Drop-Off
              </InterItalicText>
            </>
          ) : (
            <>
              <PingFangMediumText color={'#FFFFFF'} fontSize={24} marginTop={8}>
                配送员
              </PingFangMediumText>
            </>
          )
        }
      </Button>
      {
        // 指定柜子不显示底部图标
        ![87, 88].includes(cabId) && (
          <div style={{ marginTop: 5, marginLeft: 2 }}>
            {/* DHL */}
            <img src={Dhl} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: -85, marginTop: -45, zIndex: 80 }} />
            {/* Amazon */}
            <img src={Amazon} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: -70, marginTop: -20, zIndex: 78 }} />
            {/* AusPost */}
            <img src={AusPost} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: -53, marginTop: -35, zIndex: 80 }} />
            {/* HelloFresh */}
            <img src={HelloFresh} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: -40, marginTop: -10, zIndex: 77 }} />
            {/* Toll */}
            <img src={Toll} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: -20, marginTop: -35, zIndex: 76 }} />
            {/* Panda */}
            <img src={Panda} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: -10, marginTop: -13, zIndex: 77 }} />
            {/* Fantuan */}
            <img src={Fantuan} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: 15, marginTop: -33, zIndex: 77 }} />
            {/* Uber */}
            <img src={Uber} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: 22, marginTop: -10, zIndex: 76 }} />
            {/* Dash */}
            <img src={Dash} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: 35, marginTop: -45, zIndex: 76 }} />
            {/* MenuLog */}
            <img src={MenuLog} style={{ width: 33.71, borderRadius: 33.71, position: 'absolute', marginLeft: 45, marginTop: -23, zIndex: 75 }} />
          </div>
        )
      }
    </>
  );
};

export interface Props {
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setDriverId: (driverId: number) => void;
  cabId: number;
  cab?: Cab;
  setSmallCabId: (smallCabId?: number) => void;
  setLargeCabId: (largeCabId?: number) => void;
}

export default FoodItem;
